const baseStyle = {
  borderColor: 'dark7',
  opacity: 1,
};

export const Divider = {
  baseStyle,
};
